import type { Signal } from '@angular/core';
import { inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';

import { FeatureSpecSelectors } from '@core/feature-spec-data';
import { FeatureCode } from '@core/feature-spec-types';

@Injectable({ providedIn: 'root' })
export class FeatureSpecFacade {
  private readonly store = inject(Store);

  public selectIsEnabled(featureCode: FeatureCode): Signal<boolean> {
    return this.store.selectSignal(FeatureSpecSelectors.isEnabled(featureCode));
  }

  public selectIsEntitled(featureCode: FeatureCode): Signal<boolean> {
    return this.store.selectSignal(FeatureSpecSelectors.isEntitled(featureCode));
  }

  public selectConfig<T extends FeatureCode>(feature: T) {
    return this.store.selectSignal(FeatureSpecSelectors.config(feature));
  }
}
